import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserClaims } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';
import { UserContext } from './context';
import { UserInfo } from '../../models/IUserDetails';
import { GetOktUserToken } from '../../services/okta-service';
import { GetUserDetails } from '../../services/user-service';
import { Modal, Card, Text } from '@nike/eds';

/**
 * A read-only context for User information.
 * It will forget any user info when user isn't authenticated.
 * Update userInfo when authState or oktaAuth changes.
 * @param { children } props  – React props with children
 */
export const User: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const { authState, oktaAuth } = useOktaAuth();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | undefined>();
  const [isOktaCallFailed, setIsOktaCallFailed] = useState(false);

  useEffect(() => {
    if (authState?.isAuthenticated) {
      GetOktUserToken()
        .then(res => {
          if (res.data === null || res.data === undefined) {
            setIsOktaCallFailed(true);
            return;
          }
          sessionStorage.setItem('passplay-token', res.data);
          GetUserDetails()
            .then(pRes => {
              setUserInfo(prev => ({ ...prev, passplayUser: pRes.data }));
            })
            .catch(() => {
              setIsOktaCallFailed(true);
            });
        })
        .catch(() => {
          setIsOktaCallFailed(true);
        });
    } else {
      setUserInfo(undefined);
    }
  }, [authState, oktaAuth]);

  const handleDismiss = () => {
    setIsOktaCallFailed(false);
    navigate('/login');
  };

  return (
    <UserContext.Provider value={userInfo}>
      {children}
      <Modal
        hideFade
        isOpen={isOktaCallFailed}
        headerSlot={<center>Uh Oh!</center>}
        onDismiss={handleDismiss}
      >
        <Card style={{ textAlign: 'center', padding: '15px' }}>
          <Text className="okta_fail_modal">
            Employee information is not found or Incorrect. Please contact service desk and create a
            incident with assignment group &apos;GAP-EIAM-Tier_1&apos;
          </Text>
        </Card>
      </Modal>
    </UserContext.Provider>
  );
};
